<template>
  <div class="preview-wrapper w-transition" :class="[{'preview-wrapper-active': styleState}]">
    <div class="preview-header w-transition" :class="{'header-active': styleState}">
      <w-nav-bar :icon="'iconchevron-left'" :cvShow="true" :nav_title="cv.basic_info.cv_name"
        @mobileLeftBtn="leftBtnClick">
          <div slot="rightContent" class="export-btn" @click="clickOperating({type: 'export'})">
            导出
          </div>
      </w-nav-bar>
<!--      <div class="tab-wrapper" :class="{'ios-top': isIos}">-->
<!--        <div class="tab-list">-->
<!--          <w-tab :tabList="tabList" :currentTab="currentTab" @changeTab="changeTab"/>-->
<!--        </div>-->
<!--      </div>-->
    </div>
    <div class="w-transition scroll-container" :class="{'preview-container': styleState}" v-if="formatInfo">
      <cube-scroll :data="[formatInfo.line_spacing]" ref="scroll">
        <div v-show="currentTab === 0" ref="cvContainer" class="cv-dom-wrapper">
          <div class="cv-container" v-if="!loadingShow && formatInfo">
            <file-cv/>
          </div>
          <div class="calc-height" ref="calcHeight"></div>
        </div>
        <mobile-cv v-show="currentTab === 1" page-type="preview"/>   
      </cube-scroll>
    </div>
    <resumesTemplate v-show="!layoutState && !iosStyleState && !styleState" @change="dealHtml"></resumesTemplate>
    <layoutPopup v-if="layoutState" :state="layoutState" @handleClose="closeWindow"></layoutPopup>
    <preview-style :state="iosStyleState" :pageText="pageText" @onePage="onePage" @closeWindow="closeWindow"
                   @change="dealHtml"/>
    <stylePopup class="style-popup w-transition" :class="{'style-popup-active': styleState}" :style-state="styleState"
                :one-page-show="onePageShow" @onePage="onePage" @change="dealHtml" @handleClose="closeWindow"/>
    <w-share-wx :state="shareWxState" @handleClose="closeWindow"/>
    <wx-download :dialog-show="dialogShow" @closeWindow="closeWindow"/>
    <cv-export :export-state="exportState" :cv-settings="cvSettings" @closeWindow="closeWindow" @exportCv="exportCv" @changeSwitchValue="changeSettingsValue"/>
    <name-privacy :setting-show="changeNameShow"
                  :cv-data="{ token: cv.basic_info.token, cv_name: cv.basic_info.cv_name }" @refresh="refreshName"
                  @handleClose="changeNameShow = false"/>
    <w-loading v-if="loadingShow"/>
    <await-loading v-show="awaitLoadingShow" :show-text="true"/>
    <w-dialog :dialog-show="imgShow" top="10" @handleClose="closeWindow">
      <div class="flex-column-center" slot="content">
        <div class="img-container">
          <img :src="cvImgSrc" alt/>
        </div>
        <div v-if="!isHarmony" class="img-bottom flex-center">长按图片保存至相册</div>
				<div v-else class="img-bottom save-image-btn flex-center" @click="handleSaveImage">点击保存至相册</div>
      </div>
    </w-dialog>
    <cv-preview-bottom class="w-transition" :class="{'preview-bottom-active': styleState || layoutState}" @handleClick="clickOperating"
                       pageText="导出"/>
    <cv-comment-guide :cv-comment-state="cvCommentState" @handleClose="closeCommentState" />
    <editor-more :more-state="moreState" @refresh="refreshName" @handleClose="changeMoreState" @changeCv="changeCv"/>
    <div id="download-container"></div>
<!--    <nps :isShow="npsFlag" v-on:showNps="showNps" :token="token"/>-->
    <recommend-job :recommend-state="recommendState" :job-data="jobData" :hide-profile="hideProfile" @handleClose="recommendState = false" />
  </div>
</template>

<script>
	import { mapActions, mapState } from 'vuex'
	import { componentsMixin } from '../../assets/js/mixin/components'
	import { cvMixin, cvShareMixin } from '../../assets/js/mixin/cv'
	import { envMixin, eventMixin } from '../../assets/js/mixin/global'
	import WNavBar from '../../components/global/w-navbar'
	import progressBar from '../../components/cv/progress-bar'
	import cvPreviewBottom from '../../components/cv/cv-preview-bottom'
	import WLoading from '../../components/global/w-loading'
	import WDialog from '../../components/global/w-dialog'
	import WTab from '../../components/global/w-tab'
	import WShareWx from '../../components/global/w-share-wx'
  import CvCommentGuide from './cv-comment-guide'
	import fileCv from '../cv-components/file-cv'
  import RecommendJob from '../cv-components/RecommendJob'
	import namePrivacy from '../cv-components/name-privacy'
	import wxDownload from '../cv-components/wx-download'
	import cvExport from '../cv-components/cv-export'
	import editorMore from '../cv-editor/editor-more'
	import previewStyle from './preview-style'
  import resumesTemplate from './resumesTemplate'
  import layoutPopup from '@/views/cv-preview/layout-popup'
	import mobileCv from '../cv-editor/mobile-cv'
	import stylePopup from './style-popup'
	import { getPng } from '../../assets/js/htmlToPdf'
	import { userMixin } from '../../assets/js/mixin/user'
  import resumeTemplateData from "../../assets/json/recommend-template-style"
	import nps from '../../components/nps/index'
	import Cookies from 'js-cookie'

	export default {
		head () {
			return {
				title: '预览'
			}
		},
		mixins: [ componentsMixin, envMixin, cvMixin, userMixin, eventMixin, cvShareMixin ],
		name: 'preview',
		data () {
			return {
        resumeTemplateData,
				token: this.$route.params.token,
				onePageShow: false,
				loadingShow: true,
				awaitLoadingShow: false,
				styleState: false,
				iosStyleState: false,
				exportState: false,
				shareWxState: false,
				dialogShow: false,
				changeNameShow: false,
				tabList: [ { label: '文件预览', type: 'doc' }, { label: '手机预览', type: 'mobile' } ],
				currentTab: 0,
				jobHasClick: false,
				currentLh: 0,
				cvImgSrc: '',
				imgShow: false,
				npsFlag: false,
				user_id: '',
				moreState: false, // 更多的弹窗
        cvCommentState: false,
        hideProfile: false,
        recommendState: false, // 下载简历点击邮箱60分以上弹窗推荐职位
        jobData: {}, // 阻断推荐职位的数据
				encodedToken: '',
				cvSettings: {},
        layoutState: false, // 布局调整
			}
		},
		async created () {
			try {
				this.initOnlineState()
				await this.getEncodedToken()
				this.getSettingsValue(this.encodedToken)
				await this._getCv()
				// this.onePage(null, true)
				// this.isShowNps()
				this.getJobByCv()
			} catch (error) {
				console.log(error)
			}
		},
		computed: {
			...mapState('cv', [ 'cv', 'sortAry', 'score' ]),
			pageText () {
				return this.onePageShow ? '取消一页纸' : '自动一页纸'
			},
			formatInfo () {
				return this.cv.format_info
			}
		},
		watch: {},
		components: {
			cvPreviewBottom,
			WLoading,
			WTab,
			WNavBar,
			WShareWx,
			previewStyle,
			progressBar,
			mobileCv,
			namePrivacy,
			wxDownload,
			cvExport,
			fileCv,
			stylePopup,
			WDialog,
			awaitLoading: WLoading,
			nps,
			editorMore,
      CvCommentGuide,
      RecommendJob,
      layoutPopup,
      resumesTemplate
		},
		methods: {
			...mapActions('cv', ['getCvDetail']),
			leftBtnClick () {
				window.history.back()
			},
			// 修改简历名称的弹窗
			changeCv () {
				this.changeNameShow = true
			},
			changeMoreState () {
				this.moreState = !this.moreState
			},
			// 关闭所有弹窗
			closeWindow () {
				this.iosStyleState = false
				this.styleState = false
				this.exportState = false
				this.shareWxState = false
				this.dialogShow = false
				this.imgShow = false
        this.layoutState = false
			},
      // 关闭点评引导提示
      closeCommentState() {
			  this.cvCommentState = false
      },
			// 切换手机预览还是文件预览
			changeTab (item, index) {
				this.currentTab = index
			},
			// 底部bar点击事件
			clickOperating (item) {
				if (item.type === 'style') {
					if (this.isIos) {
						this.iosStyleState = true
					} else {
						this.styleState = true
					}
					this.currentTab = 0
				} else if (item.type === 'export') {
					if (this.onlineState) {
						this.createOnlineCvDialog()
					} else {
						this.exportState = true
            if (!this.$db.ls.get('cvComment')) {
              this.cvCommentState = true
            }
					}
				} else if (item.type === 'more') {
					this.changeMoreState()
				} else if (item.type === 'buju') {
          this.layoutState = true
				}
			},
			// 导出简历按钮方法
			async exportCv (item, hideProfile) {
			  this.hideProfile = hideProfile
				switch (item.type) {
					case 'wechat':
						if (this.isWxMini) {
							this.$wechat.miniProgram.navigateTo({
								url: `/pages/cvShare/cvShare?url=${ process.env.VUE_APP_HOST }/cvs/${ this.encodedToken }/share&title=${ this.cv.basic_info.cv_name }`
							})
						} else {
							this.$router.push(`/cvs/${ this.encodedToken }/share`)
						}
						this.$db.ls.set('shareByPreview', true)
						this.exportState = false
						break
					case 'email':
            this.exportState = false
            // let isDownloadCvJob = this.$db.ls.get('isDownloadCvJob')
					  // if (!isDownloadCvJob && this.score > 60) {
					  //   setTimeout(() => {
            //     this.recommendState = true
            //   }, 200)
            // } else {
              this.$router.push('/cvs/send-email?token=' + this.$route.params.token + '&cv_name=' + this.cv.basic_info.cv_name + '&hideProfile=' + hideProfile)
            // }
						break
					case 'pic':
					case 'local':
						return;
					// case 'pic':
					// 	if (this.isWechatBrowser || this.isWxMini) {
					// 		this.exportState = false
					// 		this.dialogShow = true
					// 	} else {
					// 		// this.getCvPng()
          //     this.getCvPngByUrl()
					// 		this.exportState = false
					// 	}
					// 	break
					// case 'local':
					// 	this._checkCvName()
					// 	break
				}
			},
			// 导出简历时检查简历名称是否符合规范
			_checkCvName () {
				let nameField = [ '未命名简历', '个人简历', '求职简历', '(复制)', '(翻译)', '(导师)' ]
				let show = this.$db.ls.get(`${ this.token }-export`)
				let check = false
				for (let i = 0; i < nameField.length; i++) {
					if (this.cv.basic_info.cv_name.includes(nameField[i]) && !show) {
						check = true
					}
				}
				if (check) {
					this.exportState = false
					this.$createDialog({
						title: '温馨提示',
						type: 'confirm',
						content: `当前简历名称不规范，建议修改后继续`,
						confirmBtn: {
							text: '修改',
						},
						cancelBtn: {
							text: '跳过',
						},
						onConfirm: () => {
							this.changeNameShow = true
						},
						onCancel: () => {
							this._exportCv(true)
						}
					}).show()
				} else {
					this._exportCv()
				}
			},
			// 导出简历中导出至本地按钮的方法
			async _exportCv (showDialog) {
				if (showDialog) this.$db.ls.set(`${ this.token }-export`, true)
				if (this.isWechatBrowser || this.isWxMini) {
					this.exportState = false
					this.dialogShow = true
				} else if (this.isHarmony) {
					let res = await this.$api.cv.downloadCv(this.$route.params.token, {
						watermark: 'no',
            hideProfile: this.hideProfile,
            origin: 'pc'
					})
					if (res.code === 1000) {
						window.harCallBack?.openFile?.(res.data.url, `${this.cv.basic_info.cv_name}.pdf`)
						// this.handlerBridge('combineDownload', {
						// 	url: res.data.url,
						// 	name: this.cv.display_name
						// })
					} else {
            this.$router.push('/buy/member/order')
          }
					this.exportState = false
				} else {
					this.exportState = false
					window.location.href = 'https://datayi.cn/w/woVLaZWR'
				}
			},
			// 更新简历名称时更新navBar上的面的名称
			refreshName (name) {
				this.cv.basic_info.cv_name = name
				this.changeNameShow = false
			},
			// 获取简历png图片 
			async getCvPng () {    
				let el = document.querySelector('#pdfDom')
				let cloneEl = el.cloneNode(true)
				cloneEl.removeChild(cloneEl.children[1])
				cloneEl.style.transform = 'scale(1)'
				let downloadEl = document.querySelector('#download-container').appendChild(cloneEl)
				this.awaitLoadingShow = true
				getPng(downloadEl)
					.then(dataUrl => {
						this.cvImgSrc = dataUrl
						this.awaitLoadingShow = false
						this.imgShow = true
						document.querySelector('#download-container').removeChild(cloneEl)
					}).catch(error => {
					console.error('something went wrong', error)
				})
			},
      // 调用接口保存简历图片到本地
      async getCvPngByUrl () {
        this.awaitLoadingShow = true
	      let res = await this.$api.cv.downloadCvImage(this.$route.params.token, {
          watermark: 'no',
          hideProfile: this.hideProfile,
          origin: 'pc'
        })
        if(res.code === 1000) {
          this.cvImgSrc = res.data.url
        } else {
          this.$router.push('/buy/member/order')
        } 
        this.awaitLoadingShow = false
				this.imgShow = true
      },
			handleSaveImage() {
				window.harCallBack?.openFile?.(this.cvImgSrc, `${this.cv.basic_info.cv_name}.png`)
			},
			// 自动一页纸逻辑
			async onePage (click, init) {
				await this.changeTab({}, 0)
				let currentLh = this.cv.format_info.line_spacing,
					currentH = document.querySelector('#resumeEditor').offsetHeight,
					pageMargin = this.cv.format_info.page_margin,
					mmPx = this.$refs.calcHeight.getBoundingClientRect().height,
					onePageH = (297 - 2.45 * pageMargin) * mmPx.toFixed(2);
				if (!this.onePageShow || init) {
					if (currentH >= onePageH) {
						for (let i = currentLh; i >= 12; i--) {
							this.cv.format_info.line_spacing = i
							await this.dealHtml()
							await this.$forceUpdate()
							let height = document.querySelector('#resumeEditor').offsetHeight
							if (height <= onePageH) {
								if (click) this.onePageShow = true
								this.showToast('"智能一页"设置成功', 2000)
								this.updateLineHeight()
								return 0
							} else if (height > onePageH && i === 12) {
								if (click) {
									this.onePageShow = true
									this.showToast('内容过多无法在一页纸内，请删减内容再次尝试', 2000)
								}
								this.updateLineHeight()
							}
						}
					} else {
						for (let i = currentLh; i <= 28; i++) {
							this.cv.format_info.line_spacing = i
							await this.dealHtml()
							await this.$forceUpdate()
							let height = document.querySelector('#resumeEditor').offsetHeight
							if (height + 54 >= onePageH) {
								if (click) this.onePageShow = true
								this.showToast('"智能一页"设置成功', 2000)
								this.updateLineHeight()
								return 0
							} else if (height < onePageH && i === 28) {
								if (click) {
									this.onePageShow = true
									this.showToast('内容过少无法调整为一页纸，请添加内容再尝试', 2000)
								}
								this.updateLineHeight()
							}
						}
					}
				} else {
					this.cv.format_info.line_spacing = this.currentLh
					await this.dealHtml()
					this.$forceUpdate()
					if (click) this.onePageShow = false
					this.updateLineHeight()
					this.showToast('已取消"智能一页"')
				}
				this.dealEmpty()
			},
			// 判断为ios时更新一下简历的，防止自动一页纸后没有调整格式直接点击下载
			updateLineHeight () {
				if (this.isIos) {
					this.$api.cv.updateCvFormat({
						line_spacing: this.cv.format_info.line_spacing,
						cv_token: this.$route.params.token
					})
				}
			},
			async _getCv () {
				// this.loadingShow = true
				await this.getCvDetail({ token: this.token })
				await this._getModuleInfoByApi()
				let formatInfo = JSON.parse(JSON.stringify((this.cv.format_info)))
				this.currentLh = formatInfo.line_spacing
				this.dealHtml()
				this.loadingShow = false
				this.$forceUpdate()
				setTimeout(() => {
					this.dealEmpty()
				}, 700)
			},
			// 格式化简历格式之后的问题
			dealHtml (type, lh) {
				if (type === 'change') {
					this.showToast('更新简历格式成功')
					this.currentLh = lh
					this.onePageShow = false
					this.styleState = false
					this.iosStyleState = false
          this.layoutState = false
					if (this.isIos) this.dealEmpty()
				}
				this.state = false
			},
			// 关闭nps
			showNps () {
				this.npsFlag = false
			},
			// 判断是否展示过nps
			isShowNps () {
				this.$api.nps.isShowNps(this.cvAccountToken, { channel: this.isWxMini ? 3 : this.isIos ? 2 : 4 })
					.then(res => {
						if (res.code === 1000) {
							if (res.data.is_fill) {
								let time = setTimeout(() => {
									this.npsFlag = true
									clearTimeout(time)
								}, 2000)
							}
						}
					})
			},
      // 获取下载简历推荐职位阻断数据
      async getJobByCv() {
			  try {
			    let isDownloadCvJob = this.$db.ls.get('isDownloadCvJob')
			    if (!isDownloadCvJob) {
            let res = await this.$api.cv.getJobByDownloadCv({
              cv_token: this.$route.params.token
            })
            if (res.code === 1000) {
              this.jobData = res.data
            }
          }
        } catch (e) {
          console.log(e)
        }
      },
		}
	}
</script>

<style lang="scss" scoped>
  @import "@/assets/scss/global/variable";
  @import "@/assets/scss/global/mixin";
  .export-btn {
    width: 48px;
    height: 24px;
    background: #4183FF;
    border-radius: 12px;
    color: #fff;
    font-size: 14px;
    text-align: center;
    line-height: 24px;
    position: relative;
    right: -12px;
  }
  .preview-wrapper {
    background-color: #101010;
    min-height: calc(var(--vh, 1vh) * 100);
    padding-top: 44px;
    padding-bottom: 64px;
    width: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
    overflow: hidden;
    @include ipx-content-bottom(1px);
    .preview-header {
      position: fixed;
      top: 0;
      left: 0;
      z-index: 9;
      width: 100vw;
      height: 44px;
      .mobile-nav {
        border: none;
        background-color: #101010;
        color: $color-light;
        /deep/ .nav-title {
          color: $color-light;
        }
      }
    }
    .header-active {
      transform: translateY(calc(-100% - 2px));
    }
    .scroll-container {
      height: calc(calc(var(--vh, 1vh) * 100) - 295px);
    }
    .preview-container {
      transform: perspective(1px) scale(0.9);
      margin-top: -65px;
    }
    .calc-height {
      height: 1mm;
      background-color: transparent;
    }
    .preview-bottom-active {
      transform: translateY(calc(100% + 20px));
    }
  }
  .preview-wrapper-active {
    background-color: #101010;
  }
  .style-popup {
    transform: translateY(74px);
  }
  .style-popup-active {
    transform: translateY(0);
  }
  .img-container {
    height: calc(var(--vh, 1vh) * 70);
    overflow: scroll;
    &::-webkit-scrollbar {
      display: none;
    }
    img {
      width: 90vw;
    }
  }
  .img-bottom {
    height: 36px;
    padding: 0 20px;
    border-radius: 18px;
    background-color: $color-title;
    color: #cbcbcb;
    margin-top: 20px;
  }
	.save-image-btn {
		background-color: $color-theme;
		color: #fff;
	}
  #download-container {
    transform: translateX(-200%);
  }
</style>
